/* Global initialization functions
 *
 * This is the entry point for our app and is the first module concatenated into c2.js and
 * c2.min.js. Thus, any global configuration that other c2 modules depend on should be added
 * here at the module level so it can be executed immediately.
 * Copied and modified from: static_src/js/c2Archive/init.js
 */


/*
 * Global c2 object contains settings and will have all modules registered as members
 * once all c2.js code has executed.
 */
window.c2 = {

  /*
   * Global c2.settings
   */
  settings: {

    /*
     * Logging settings.
     * See c2.logging for more details.
     */
    logging: {
      // To enable console logging for a c2 module, add it to this list.  All c2 modules reside in
      // static_src/js/c2/.  Use the exported module name (which sometimes differs from the file
      enabledModules: [],
      // name), e.g.  'server', 'dependentFields'

      // Log level determines the importance of messages that are logged:
      //   debug: show debug, info, warning and error messages.
      //   info: show info, warning, and error messages.
      //   warn: show warnings and errors.
      //   errors are always logged when the module is enabled
      level: 'info'
    },
    urls: {}

  }

};


/*
 * This function is the entry point for our JavaScript.  It must be called from a Django template
 * that has the ability to inject these values.
 */
c2.go = function (
  CBLicenseID,
  mixpanelToken,
  CSRFToken,
  staticURL,
  loginURL,
  logoutURL,
  activityURL,
  detectTimeZone,
  timeoutMin) {

  c2.settings.CBLicenseID = CBLicenseID;
  c2.settings.mixpanelToken = mixpanelToken;
  c2.settings.CSRFToken = CSRFToken;
  c2.settings.urls.static = staticURL;
  c2.settings.urls.login = loginURL;
  c2.settings.urls.logout = logoutURL;
  c2.settings.urls.activity = activityURL;

  // Send a Django encrpytion token with every AJAX request
  $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    if (!options.crossDomain) {
      // only set token on same-domain requests to avoid leaking it to 3rd parties
      jqXHR.setRequestHeader('X-CSRFToken', CSRFToken);
    }
  });

  $.ajaxSetup({
    // Global error handler that redirects the whole page to the login page if the session is expired:
    // See https://cloudbolt.atlassian.net/browse/DEV-194
    //
    // NOTE: If the .ajax() calls contain another error handler, then BOTH that
    // handler and this global handler will be called.
    //
    // Unfortunately, this does not apply to $.get or $.post calls, which
    // bypass use of jqXHR; we may want to move to using $.ajax everywhere.
    error: function (data) {
      console.log('    Ajax error occurred:', data);

      if (data.status == 401) {
        console.log('    401: session expired. Redirect to log in page.');
        window.location.replace(
          loginURL + "?next=" + encodeURI(window.location.pathname)
        );
      }
    }
  });

  function handleInactivity() {
    window.location.href = logoutURL + '?inactivity-timeout-minutes=' + timeoutMin;
  }

  if (timeoutMin) {
    c2.inactivity.init(timeoutMin, handleInactivity, activityURL);
  }

  if (detectTimeZone) {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // All modern browsers support the new Internationalization API; ignore otherwise.
    if (tz !== undefined) {
      $.post('/detect_time_zone', {
        tz: tz
      });
    }
  }
};


/*
 * Global initializations that run on document load.
 */
$(function () {
  'use strict';

  // Safely initialize each module, logging errors instead of crashing the page
  var modules = [
    ['accessibility', function () { c2.accessibility.init(); }],
    ['alerts', function () { c2.alerts.init(); }],
    ['clipboard', function () { c2.clipboard.init(); }],
    ['include', function () { c2.include.loadAll(); }],
    ['dialogs', function () { c2.dialogs.init(); }],
    ['dataTables', function () { c2.dataTables.init(); }],
    ['navbar', function () { c2.navbar.init(); }],
    ['tooltips', function () { c2.tooltips.init(); }],
    ['toggles', function () { c2.toggles.enablePostOnChange(); }],
    ['search', function () { c2.search.init(); }],
    ['commonEventHandlers', function () { c2.commonEventHandlers.bindGlobalKeyHandlers(); c2.commonEventHandlers.enablePostOnClick(); }],
    ['when', function () { c2.when.upgradeAll(); }],
  ];

  modules.forEach(function (entry) {
    var name = entry[0], fn = entry[1];
    try {
      if (!c2[name]) {
        console.error('c2.' + name + ' module is not registered. Check c2.js for script errors before this module.');
        return;
      }
      fn();
    } catch (e) {
      console.error('c2.' + name + ' initialization failed:', e);
    }
  });

  // Customers may completely disable mixpanel by assigning settings.MIXPANEL_TOKEN = ''
  if (c2.settings.mixpanelToken !== '') {
    if (c2.mixpanel) {
      c2.mixpanel.init();
    }
  }
});

/*
 * c2.sparklines — lightweight, dependency-free bar sparklines for v5.
 *
 * Replaces the legacy jquery.sparkline plugin (not bundled in v5). Renders a
 * row of colored bars inside any `.sparkline` element. Bar values are read
 * from a `data-times` attribute or from an HTML comment inside the element
 * (e.g. <span class="sparkline" data-colors="green,red"><!-- 12,40 --></span>),
 * matching the server-rendered markup. Per-bar colors come from the
 * comma-separated `data-colors` attribute.
 */
(function (c2) {
  'use strict';

  function readValues(el) {
    var data = el.getAttribute('data-times');
    if (!data) {
      for (var i = 0; i < el.childNodes.length; i++) {
        // nodeType 8 === comment node
        if (el.childNodes[i].nodeType === 8) {
          data = el.childNodes[i].nodeValue;
          break;
        }
      }
    }
    return (data || '')
      .split(',')
      .map(function (n) { return parseFloat(n); })
      .filter(function (n) { return !isNaN(n); });
  }

  function render(el) {
    var values = readValues(el);
    if (!values.length) return;
    var colors = (el.getAttribute('data-colors') || '').split(',');
    var max = Math.max.apply(null, values) || 1;

    el.textContent = '';
    el.style.display = 'inline-flex';
    el.style.alignItems = 'flex-end';
    el.style.gap = '2px';
    el.style.height = '20px';

    values.forEach(function (val, idx) {
      var bar = document.createElement('span');
      bar.style.display = 'inline-block';
      bar.style.width = '5px';
      bar.style.borderRadius = '1px';
      bar.style.height = Math.max(2, Math.round((val / max) * 20)) + 'px';
      bar.style.backgroundColor =
        colors[idx] || colors[colors.length - 1] || '#888';
      el.appendChild(bar);
    });
  }

  function init(selector) {
    var nodes = document.querySelectorAll(selector || '.sparkline');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.dataset.c2Sparkline) return;
      render(el);
      el.dataset.c2Sparkline = '1';
    });
  }

  c2.sparklines = { init: init, render: render };

  $(function () { init(); });
})(window.c2 = (window.c2 || {}));
